import { render, staticRenderFns } from "./MatricularFuncionarios.vue?vue&type=template&id=a4860cee&"
import script from "./MatricularFuncionarios.vue?vue&type=script&lang=js&"
export * from "./MatricularFuncionarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports